import { render, staticRenderFns } from "./SettingsIcon.vue?vue&type=template&id=d4802686&"
import script from "./SettingsIcon.vue?vue&type=script&lang=js&"
export * from "./SettingsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports